import ClassicBridge from "../next/ClassicBridge";
import {convertNextKanbanSummaryToClassicKanbanInitial} from "../next/utils"
import {
    fillNextDataParams,
    fillNextParamsWithOnlyManageableTasks,
    fillNextParamsWithTaskNameFilter,
    loadAndMergeRpcAndNextData,
    NEXT_SORTING_FIELDS,
} from './tasksTable/connector'

export default class TaskManagementService {
    loadKanbanInitial(cpSelection, workflowStatusFilter, customFieldsFilters, taskWorkflowStatuses, wordFilter, onlyManageableTasks) {
        const params = {
            customFieldsFilters
        }

        fillNextDataParams({
            intersectedCPSelection: cpSelection,
            taskStatusFilter: workflowStatusFilter,
            taskNameFilter: wordFilter,
            showOnlyManageableTasks: onlyManageableTasks,
        }, {
            taskWorkflowStatuses
        })(params)

        return ClassicBridge.getKanbanSummary(params).then(nextData => convertNextKanbanSummaryToClassicKanbanInitial(nextData))
    }

    loadKanbanTasks(projectId, intersectedCPSelection, filteredWorkflowStatusIds, customFieldsFilters, taskWorkflowStatuses, wordFilter, onlyManageableTasks, offset, limit) {
        const params = {
            projectIds: [projectId],
            customFieldsFilters,
            offset,
            limit,
            sortField: NEXT_SORTING_FIELDS.KANBAN_POSITION,
            ascSort: false
        }

        fillNextParamsWithOnlyManageableTasks(params, onlyManageableTasks)
        fillNextParamsWithTaskNameFilter(params, wordFilter)

        return Promise.all(filteredWorkflowStatusIds.map((workflowStatusId) => {
            return ClassicBridge.getTasksForTaskList({
                workflowStatusIds: [workflowStatusId],
                ...params
            })
        })).then((result) => {
            const tasks = result.map((data) => data.items).flat()

            return loadAndMergeRpcAndNextData({ items: tasks }, intersectedCPSelection)
        })

    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/TaskManagementService.js